import React from "react";
import { Button, Card, Row } from "reactstrap";
import Counter from "../Counter";
import { useTranslation } from "react-i18next";
import { PAYMENT_CANCELED_TIMEOUT } from "../../Constants";

const PaymentCanceled = (preps) => {
  const { handleContinue, timeoutEnabled = true } = preps;
  const { t } = useTranslation();

  return (
    <>
      <Card className='d-flex align-items-center justify-content-center flex-wrap'>
        <div className='mt-4 mb-4'>
          <h2>{t("payment-canceled")}</h2>
        </div>
        <div className='mb-3'>{t("redirecting-to-merchant")}</div>
        {timeoutEnabled && <Counter counterTimeout={PAYMENT_CANCELED_TIMEOUT} onTimeout={handleContinue} />}
        <Row className='my-3'>
          <Button color='danger' size='sm' className='mt-2 mb-4' onClick={handleContinue}>
            {t("redirect-now")}{" "}
          </Button>
        </Row>
      </Card>
    </>
  );
};

export default PaymentCanceled;
